import {
  getAll,
  getPage,
  loadDailyTrips,
  getDailyReport,
} from '@/api/tripserv'

export default {
  state: {
    state_Trip_GetAllResult: null,
    state_Trip_GetPageResult: null,
    state_Trip_LoadDailyTripsResult: null,
    state_Trip_GetDailyReportResult: null,
  },
  mutations: {
    SET_TRIP_GETALL_RESULT: (state, rst) => {
      state.state_Trip_GetAllResult = rst;
    },
    SET_TRIP_GETPAGE_RESULT: (state, rst) => {
      state.state_Trip_GetPageResult = rst;
    },
    SET_TRIP_LOADDAILYTRIPS_RESULT: (state, rst) => {
      state.state_Trip_LoadDailyTripsResult = rst;
    },
    SET_TRIP_GETDAILYREPORT_RESULT: (state, rst) => {
      state.state_Trip_GetDailyReportResult = rst;
    },
  },
  actions: {
    TripServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRIP_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRIP_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TripServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRIP_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRIP_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TripServ_LoadDailyTrips({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        loadDailyTrips(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRIP_LOADDAILYTRIPS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRIP_LOADDAILYTRIPS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TripServ_GetDailyReport({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDailyReport(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRIP_GETDAILYREPORT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRIP_GETDAILYREPORT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_Trip_GetAllResult: state => {
      return state.state_Trip_GetAllResult;
    },
    get_Trip_GetPageResult: state => {
      return state.state_Trip_GetPageResult;
    },
    get_Trip_LoadDailyTripsResult: state => {
      return state.state_Trip_LoadDailyTripsResult;
    },
    get_Trip_GetDailyReportResult: state => {
      return state.state_Trip_GetDailyReportResult;
    },
  }
}